enum ItemsAndGroupsStockStatus {
  All = 'all',
  InStock = 'inStock',
  OutOfStock = 'outOfStock',
}

export default ItemsAndGroupsStockStatus;
